import styled from 'styled-components';

export const StyledModalContent = styled.div`
  padding: 4rem 4.6rem 0;
  text-align: center;
  h2 {
    font-size: 3.2rem;
    span {
      color: ${({ theme }) => theme.colors.primary.main};
      text-transform: capitalize;
    }
  }
  h2,
  p {
    margin-bottom: 1.6rem;
  }
`;

export const StyledImageWrapper = styled.figure<{ $isEarned?: boolean }>`
  width: 100%;
  margin-bottom: 2.4rem;
  position: relative;
  filter: ${({ $isEarned }) => ($isEarned ? 'none' : 'grayscale(100%)')};
  opacity: ${({ $isEarned }) => ($isEarned ? '1' : '0.4')};
  img {
    height: auto;
    max-height: 15rem;
    width: inherit;
    object-fit: contain;
  }
`;
